import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "assets/css/MiniCalendar.css";
import { Icon, Button, Box } from "@chakra-ui/react";
import { MdChevronLeft, MdChevronRight, MdToday } from "react-icons/md";
import Card from "components/card/Card.js";

export default function MiniCalendar(props) {
  const {
    selectRange,
    onDateChange,
    onMonthChange,
    classes = [],
    showTodayButton = true,
    value: propValue,
    onChange: propOnChange,
    ...rest
  } = props;
  const [internalValue, setInternalValue] = useState(new Date());
  const [activeStartDate, setActiveStartDate] = useState(propValue || new Date());

  const value = propValue !== undefined ? propValue : internalValue;
  const onChange = propOnChange || setInternalValue;

  const handleDateChange = (newValue) => {
    onChange(newValue);
    if (onDateChange) {
      onDateChange(newValue);
    }
  };

  const handleTodayClick = () => {
    const today = new Date();
    handleDateChange(today);
    setActiveStartDate(today);
    if (onMonthChange) {
      onMonthChange(today);
    }
  };

  const handleActiveStartDateChange = ({ activeStartDate: newActiveStartDate }) => {
    setActiveStartDate(newActiveStartDate);
    if (onMonthChange) {
      onMonthChange(newActiveStartDate);
    }
  };

  const hasClasses = (date) => {
    const dayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
    const dayEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999).getTime();
    return classes.some((classData) => classData.Date >= dayStart && classData.Date <= dayEnd);
  };

  const isSelected = (date) => {
    if (!value) return false;
    return date.toDateString() === value.toDateString();
  };

  const tileContent = ({ date, view }) => {
    if (view === "month" && hasClasses(date)) {
      const selected = isSelected(date);
      return (
        <Box
          position="absolute"
          bottom="2px"
          left="50%"
          transform="translateX(-50%)"
          w="6px"
          h="6px"
          borderRadius="full"
          bg={selected ? "white" : "brand.500"}
        />
      );
    }
    return null;
  };

  return (
    <Card
      align="center"
      direction="column"
      w="100%"
      p="30px"
      display="flex"
      {...rest}
    >
      <div style={{ position: "relative", width: "100%" }}>
        <Calendar
          onChange={handleDateChange}
          value={value}
          activeStartDate={activeStartDate}
          onActiveStartDateChange={handleActiveStartDateChange}
          selectRange={selectRange}
          view="month"
          tileContent={tileContent}
          minDate={props.minDate}
          prevLabel={<Icon as={MdChevronLeft} w="24px" h="24px" mt="4px" />}
          nextLabel={<Icon as={MdChevronRight} w="24px" h="24px" mt="4px" />}
        />
        {showTodayButton && (
          <Button
            leftIcon={<Icon as={MdToday} w="16px" h="16px" />}
            bg="secondaryGray.300"
            color="secondaryGray.900"
            onClick={handleTodayClick}
            _hover={{ bg: "secondaryGray.400" }}
            _active={{ bg: "secondaryGray.500" }}
            position="absolute"
            top="0px"
            right="60px"
            fontSize="14px"
            fontWeight="600"
            h="44px"
            minW="44px"
            borderRadius="10px"
          >
            Today
          </Button>
        )}
      </div>
    </Card>
  );
}
